module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_5012.4664aedd.png";